import { isDarkColor } from '@elfsight/lib-utils';

export function getLinearGradientColor(backgroundColor: string) {
  const hslFirstLinearColor = isDarkColor(backgroundColor)
    ? 'hsl(0 0% 100% / 0.9)'
    : `hsl(from ${backgroundColor} h calc(min(s, 85)) calc(l - 30))`;
  const hslSecondLinearColor = isDarkColor(backgroundColor)
    ? 'hsl(0 0% 100% / 0.75)'
    : `hsl(from ${backgroundColor} h calc(min(s, 85)) calc(l - 20))`;

  return {
    hslFirstLinearColor,
    hslSecondLinearColor
  };
}
